module.exports = __webpack_public_path__ + "img/L-ML2.539e11c6.jpg";